<template>
	<div style="text-align: center">
		Sorry, your page could not be found.
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>
